import { compact } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TextKey, RouteName } from '@mews-commander/enums';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getCurrentEnterpriseServiceId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { isCurrentEnterpriseCheckoutReportEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import {
    canCurrentProfileManageReservations,
    canCurrentProfileManageRates,
    canCurrentEmployeeUseTimeline,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getSimpleSearchResult } from './getSimpleSearchResult';
import { SearchResult } from './types';

export default createSelector(
    getCurrentEnterpriseId,
    getCurrentEnterpriseServiceId,
    canCurrentProfileManageReservations,
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    canCurrentEmployeeUseTimeline,
    canCurrentProfileManageRates,
    isCurrentEnterpriseCheckoutReportEnabled,
    (
        enterpriseId: string,
        serviceId: string,
        canManageReservations: boolean,
        canUseTimeline: boolean,
        canManageRates: boolean,
        checkoutReportEnabled: boolean
    ) => {
        if (!serviceId) {
            return [];
        }

        return compact<SearchResult>([
            canManageReservations
                ? getSimpleSearchResult({
                      routeName: RouteName.ReservationCreate,
                      titleKey: TextKey.NewReservation,
                      params: { query: { HotelId: enterpriseId } },
                  })
                : null,
            getSimpleSearchResult({
                routeName: RouteName.ReservationOverviewReportIndex,
                titleKey: TextKey.ReservationOverview,
                params: { query: { HotelId: enterpriseId } },
            }),
            canUseTimeline
                ? getSimpleSearchResult({
                      routeName: RouteName.ReservationDashboard,
                      titleKey: TextKey.TimeLine,
                      params: { query: { ServiceId: serviceId } },
                  })
                : null,
            getSimpleSearchResult({
                routeName: RouteName.ReservationReportIndex,
                titleKey: TextKey.ReservationReport,
            }),
            checkoutReportEnabled
                ? getSimpleSearchResult({
                      routeName: RouteName.CheckoutReportIndex,
                      titleKey: TextKey.CheckoutReport,
                  })
                : null,
            getSimpleSearchResult({
                routeName: RouteName.AvailabilityBlockReportIndex,
                titleKey: TextKey.AvailabilityBlockReport,
            }),
            getSimpleSearchResult({
                routeName: RouteName.AvailabilityReportIndex,
                titleKey: TextKey.AvailabilityOccupancyReport,
                params: { query: { PartialBind: 'true', ScopeId: enterpriseId } },
            }),
            canManageRates
                ? getSimpleSearchResult({
                      routeName: RouteName.VisitDefaultPricing,
                      titleKey: TextKey.RateManagement,
                      params: { serviceId },
                  })
                : null,
        ]);
    }
);
